export default "/_next/static/media/enjoei-advancedcategory-1024x369.8734ad71b2ea4a1aeab7d136d8fe46eb.png";